// extracted by mini-css-extract-plugin
export default {"footer":"ProductOrderFooter_footer__r188S","loader":"ProductOrderFooter_loader__8v6db"};